// en-CA formats as YYYY-MM-DD, the ISO calendar date the API expects.
const ARGENTINA_DAY = new Intl.DateTimeFormat('en-CA', {
  timeZone: 'America/Argentina/Buenos_Aires',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
});

/**
 * Today's calendar date in Argentina as YYYY-MM-DD.
 *
 * `toISOString()` gives the UTC day, which from 21:00 onwards in Buenos Aires
 * is already tomorrow: screens defaulting to "today" would show the wrong day.
 */
export function todayInArgentina(now: Date = new Date()): string {
  return ARGENTINA_DAY.format(now);
}
